import { Component, OnInit, OnDestroy } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { EventAreaItemSlot } from '../../models/event-area-item-slot';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { environment } from '../../../../../environments/environment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../../general/services/notification.service';

@Component({
  selector: 'app-booking-events-area-item-slot',
  templateUrl: './booking-events-area-item-slot.component.html',
  styleUrls: ['./booking-events-area-item-slot.component.css']
})
export class BookingEventsAreaItemSlotComponent implements OnInit, OnDestroy {

  public maxLenNameSlot = 0;
  private subscriber: Subscription;
  public quantityLetterInSlot = 0;

  constructor(
    private bookingStepService: BookingStepService,
    private bookingOrderService: BookingOrderService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
  ) { }

  ngOnDestroy(): void {
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
    this.notificationService.hide(BookingEventsAreaItemSlotComponent.name);
  }

  ngOnInit(): void {
    this.loadingSpinnerService.show();
    this.bookingStepService.initializeEventsAreaItemSlots().subscribe(
      done => {
        this.loadingSpinnerService.hide();
        this.logger.info('BookingEventsAreaItemSlotComponent: bookingStateService initialized.');
        this.initMaxSizeTitleAreaItemSlots();
        if (!this.eventAreaItemSlots || this.eventAreaItemSlots.length < 1) {
          const errorMessage = 'There are no events available';
          this.notificationService.show(BookingEventsAreaItemSlotComponent.name, errorMessage);
        }
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`BookingEventsAreaItemSlotComponent: bookingStateService reinitialized error: ${error.message}.`);
      }
    );
  }

  get eventAreaItemSlots(): EventAreaItemSlot[] {
    return this.bookingOrderService.eventAreaItemSlots && this.bookingOrderService.eventAreaItemSlots.length > 0
      ? this.bookingOrderService.eventAreaItemSlots
      : [];
  }

  onEventAreaItemSlotSelected(eventAreaItemSlot: EventAreaItemSlot): void {
    const bookingSlot = eventAreaItemSlot.bookingSlot;
    const selectedBookingDate = new Date(bookingSlot.bookingDate);
    selectedBookingDate.setHours(0, environment.globalSettings.timeToMinutes(bookingSlot.fromTime), 0, 0);
    const selectedAreaItem = eventAreaItemSlot.areaItem;
    const selectedBookingSlots = [bookingSlot];

    const orderState = BookingStepEnum.SelectBookingEventAreaItemSlots;

    this.bookingStepService.update(
      orderState,
      null,
      selectedAreaItem,
      selectedBookingDate,
      selectedBookingSlots,
    );
  }

  protected initMaxSizeTitleAreaItemSlots(): void {
    const slots = this.eventAreaItemSlots;
    if (!slots || slots.length === 0) {
      return;
    }
    let maxLenSlotName: number;
    let maxQuantityLetterInSlot: number;
    let slotNames: string[];
    slotNames = slots.map(slot => slot.name);
    this.subscriber = this.translateService.stream(slotNames).subscribe((translateSlotNames) => {
      maxLenSlotName = 0;
      maxQuantityLetterInSlot = 0;
      slotNames.forEach(slotName => {
        const maxLen = this.getMaxSizeWord(translateSlotNames[slotName]);
        const maxLetter = this.getMaxLetter(translateSlotNames[slotName]);
        if (maxLen > maxLenSlotName) {
          maxLenSlotName = maxLen;
        }
        maxQuantityLetterInSlot = maxLetter > maxQuantityLetterInSlot ? maxLetter : maxQuantityLetterInSlot;
      });
      this.maxLenNameSlot = maxLenSlotName;
      this.quantityLetterInSlot = maxQuantityLetterInSlot;
    });
  }

  private getMaxLetter(str: string): number {
    if (!str) {
      return 0;
    }
    return str.length;
  }

  private getMaxSizeWord(str: string): number {
    if (!str) {
      return 0;
    }
    return Math.max(...str.split(' ').map(v => v.length));
  }

}
